import { getAppSettings } from "../../hooks/settings/settings";

const DEFAULT_THEME_ID = "fabrix-default";
const THEME_VARIABLES = [
    "app-background-color",
    "app-panel-color",
    "app-font-color",
    "nav-bar-color",
    "nav-bar-font-color",
    "nav-bar-active-color",
    "nav-bar-active-font-color",
    "nav-bar-hover-color",
    "nav-bar-hover-font-color",
    "element-color",
    "element-reverse-font-color",
    "element-shadow-color",
    "element-font-color",
    "element-active-color",
    "element-active-font-color",
    "element-hover-color",
    "element-hover-font-color",
];

const getPublicUrl = () => {
    return process.env.PUBLIC_URL ?? "";
}

const ensureThemeLink = () => {
    let link = document.getElementById("app-theme") as HTMLLinkElement | null;
    if (!link) {
        link = document.createElement("link");
        link.id = "app-theme";
        link.rel = "stylesheet";
        document.head.appendChild(link);
    }
    return link;
}

const removeThemeLink = () => {
    const link = document.getElementById("app-theme");
    link?.remove();
}

const getThemeSettingValue = () => {
    const value = getAppSettings()?.theme;
    if (typeof value !== "string") return DEFAULT_THEME_ID;

    const themeId = value.trim().replace(/\.css$/i, "");
    if (themeId === "default-theme") return DEFAULT_THEME_ID;
    if (!themeId || !/^[a-z0-9-]+$/i.test(themeId)) return DEFAULT_THEME_ID;

    return themeId;
}

/**
 * Applies the selected theme file and removes legacy inline theme overrides.
 */
export const updateTheme = () => {
    const themeId = getThemeSettingValue();
    if (themeId === DEFAULT_THEME_ID) {
        removeThemeLink();
        return;
    }

    const themeLink = ensureThemeLink();
    const themeHref = `${getPublicUrl()}/themes/${themeId}.css`;
    if (!themeLink.href.endsWith(themeHref)) {
        themeLink.href = themeHref;
    }

    let style = document.documentElement.style
    for (const key of THEME_VARIABLES) {
        style.removeProperty(`--${key}`);
    }
}
